import screenfull from 'screenfull'
import { createLogger } from '@utils/logger'
const DEFAULT_TARGET_ID = 'floating-portal-target'

const log = createLogger('portal_target')
log.setLevel('info')

// Returns props for <FloatingPortal> so consumers can spread them.
// In fullscreen: uses the fullscreen element as root.
// Otherwise: uses a stable id so multiple portals share the same container under <body>.
export function getFloatingPortalProps(): { root?: HTMLElement; id?: string } {
  if (typeof document === 'undefined') {
    log.debug('getFloatingPortalProps: no document, returning default target id')
    return { id: DEFAULT_TARGET_ID }
  }
  if (screenfull.isEnabled && screenfull.isFullscreen && screenfull.element) {
    log.debug('getFloatingPortalProps: using fullscreen element as root')
    return { root: screenfull.element as HTMLElement }
  }

  log.debug('getFloatingPortalProps: using default target id')
  return { id: DEFAULT_TARGET_ID }
}

// Returns a DOM element to use as the portal root.
// In fullscreen: the fullscreen element; otherwise: document.body.
export function getFloatingPortalRoot(): HTMLElement | null {
  if (typeof document === 'undefined') {
    log.debug('getFloatingPortalRoot: no document, returning null')
    return null
  }
  if (screenfull.isEnabled && screenfull.isFullscreen && screenfull.element) {
    log.debug('getFloatingPortalRoot: using fullscreen element as root')
    return screenfull.element as HTMLElement
  }

  log.debug('getFloatingPortalRoot: using document.body as root')
  return document.body
}
